import { useEffect, useState } from 'react';
import { DaDataParty } from 'react-dadata';
import { useFormContext } from 'react-hook-form';

import { ApiUserType } from '../../../../api/def_common_api';
import { useActions } from '../../../../hooks/useActions';
import { useBasket } from '../../../../hooks/useBasket';
import { useUser } from '../../../../hooks/useUser';
import { setStoreLocal } from '../../../../utils/local-storage';

export const useContactInformation = () => {
  const { profile } = useUser();
  const {
    setAddOrganization,
    setUser,
    setCheckoutValues,
    setIsPhysicalPerson,
  } = useActions();
  const { setValue } = useFormContext();
  /*  const checkType =
    user?.type === 'organization'
      ? true
      : user?.type === 'physical_person'
      ? false
      : true;*/
  const [entityTab, setEntityTab] = useState(false);

  const isUserOrg =
    !!profile?.org_name &&
    !!profile.inn &&
    !!profile.kpp &&
    !!profile.legal_address;
  const onClearValue = () => {
    const clearUser = {
      ...profile,
      org_name: '',
      legal_address: '',
      inn: '',
      kpp: '',
    };
    setValue('orgName', '');
    /*getKeys(userData).forEach((key) => {
      setValue(key, clearUser[key]);
    });*/
    setStoreLocal('org_value', {});
    setAddOrganization({} as DaDataParty);
    setUser(clearUser);
    setStoreLocal('profile', clearUser);
  };
  const toggleSwitch = (type: ApiUserType) => {
    setValue('userType', type);
    if (type === 'organization') {
      setEntityTab(false);
      setValue('is_physical_person', false);
      setIsPhysicalPerson(false);
    }
    if (type === 'physical_person') {
      setEntityTab(true);
      setValue('is_physical_person', true);
      setIsPhysicalPerson(true);
    }
  };

  return {
    profile,
    isUserOrg,
    onClearValue,
    entityTab,
    toggleSwitch,
    setEntityTab,
  };
};
